import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderComponent } from './components/loader/loader.component';
import { LoaderInterceptor } from '@core/interceptors/loader.interceptor';
import { HeaderComponent } from '@core/components/header/header.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserService } from '@core/services/user/user.service';
import { of, tap } from 'rxjs';
import { ErrorInterceptor } from '@core/interceptors/error/error.interceptor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SocketModule } from '../socket.module';
import { ToastrModule } from 'ngx-toastr';
import { IconComponent } from '@standalone/components/icon/icon.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { SharedModule } from '@shared/shared.module';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { FooterComponent } from '@core/components/footer/footer.component';
import { CookiesService } from '@core/services/cookies/cookies.service';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { ORDERS_LIMIT } from '@core/tokens/orders-limit.toket';

export const initializeApp = (
  userService: UserService,
  cookiesService: CookiesService
) => {
  const hasAuthData = !!cookiesService.getCookie('auth_data');
  if (hasAuthData) {
    return () =>
      userService.getUserInfo().pipe(
        tap((response) => {
          userService.userInfo$.next(response.data);
        })
      );
  } else {
    return () => of(null);
  }
};

@NgModule({
  declarations: [LoaderComponent, HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterLink,
    RouterLinkActive,
    SocketModule,
    ToastrModule.forRoot(),
    IconComponent,
    ReactiveFormsModule,
    TranslocoPipe,
    SharedModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
  ],
  exports: [HeaderComponent, CommonModule, LoaderComponent, FooterComponent],
  providers: [
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [UserService, CookiesService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: ORDERS_LIMIT, useValue: 6 },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RestrictionInterceptor,
    //   multi: true,
    // },
    MatSnackBar,
  ],
})
export class CoreModule {}
